export const PANE_MOTION_MS = 180;
export const PANE_MOTION_EASING = 'cubic-bezier(0.2, 0, 0, 1)';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export function prefersReducedMotion(): boolean {
    return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

export type SlideDirection = 'forward' | 'back' | 'none';
